import { render, staticRenderFns } from "./CreateContentTemplateDialog.vue?vue&type=template&id=3a157b7a"
import script from "./CreateContentTemplateDialog.vue?vue&type=script&lang=js"
export * from "./CreateContentTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports